import useClubOwnerTypeData from '../../../state/clubOwnerType/UseClubOwnerTypeData';

import Constants from '@usas/ui-web/utils/Constants';

const useClubOwnerTypeMultiselect = () => {
  const { clubOwnerTypeState } = useClubOwnerTypeData();

  // shared slice carries a '--' sentinel for the dropdown
  const options = clubOwnerTypeState.dataAsOptionsWithNames?.filter((o) => o.id !== Constants.DEFAULT_ID) || [];

  return {
    clubOwnerTypeState,
    options
  };
};

export default useClubOwnerTypeMultiselect;
